import { Box } from "@mui/material";
import { RichContent } from '@sagecentral/ckeditor';

type NoteMarkdownProps = {
    isChild: boolean;
    note: string;
};

const NoteMarkdown: React.FC<NoteMarkdownProps> = (props) => {
    const { isChild, note } = props;
    return (
        <Box sx={{
            padding: isChild ? '8px' : '16px'
        }}>
            <RichContent content={note} />
        </Box>
    );
};

export default NoteMarkdown;